module.exports = __webpack_public_path__ + "img/21.f78bba63.png";